import { IsString, IsUUID, MaxLength, ValidateIf } from 'class-validator';

export type ChatMessageSendState = 'sent' | 'failed';

export class ChatMessageSendRequest {
    @ValidateIf((data: ChatMessageSendRequest) => data.uuid !== undefined)
    @IsUUID()
    public readonly uuid?: string;

    @IsUUID()
    public readonly chatUuid: string;

    @ValidateIf((data: ChatMessageSendRequest) => data.text !== undefined)
    @IsString()
    @MaxLength(4000)
    public readonly text?: string;

    @ValidateIf((data: ChatMessageSendRequest) => data.quotedMessageUuid !== undefined)
    @IsUUID()
    public readonly quotedMessageUuid?: string;

    constructor(data?: Partial<ChatMessageSendRequest>) {
        this.uuid = typeof data?.uuid === 'string' ? data.uuid.toLowerCase() : data?.uuid;
        this.chatUuid = data?.chatUuid;
        this.text = data?.text;
        this.quotedMessageUuid = data?.quotedMessageUuid;
    }
}
